module.exports = __webpack_public_path__ + "img/trainingsschema-week-1-2.9c11a03d.png";